import logger from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { UbpEnablementData } from './UbpEnablementData.types.tsx';

const UBP_ENABLED_URL = '/api/v1/ubp/enabled';

const packageName = 'jiraRouterResourcesUbpEnablement';

/**
 * Resolves whether UBP is enabled for the current tenant.
 *
 * `null` means "unknown" — the request failed. Callers must treat it as distinct from `false`
 * so a transient failure never reads as an explicit opt-out.
 */
export const fetchUbpEnablement = async (): Promise<UbpEnablementData> => {
	try {
		const response = await performGetRequest<{ enabled: boolean }>(UBP_ENABLED_URL);
		return { isUbpEnabled: response.enabled };
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// Swallowed on purpose — an unresolved enablement must not break the route. Logged so a
		// failing endpoint is visible in Splunk instead of silently degrading every caller to `null`.
		logger.safeErrorWithoutCustomerData(`${packageName}.fetchUbpEnablement`, error.message, {
			statusCode: error?.statusCode,
			errorName: error?.name,
			description: error?.originalResponse?.message,
		});

		return { isUbpEnabled: null };
	}
};
